<script>
/**
 * @overview 课时列表 - 课时编辑
 *
 * @author huojinzhao
 */
import { mapState } from "vuex";
import store from "@/store";
import mapUtils, { $http, $token, $form, $list } from "@/utils";
import { validArray } from "../../../utils/common";

export default {
  name: "CourseListEditor",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    imgList: [],
    image: "",
    formData: null,
    initData: {
      // 课时名字
      name: "",
      // 课时标题
      title: "",
      // 教学知识点
      knowledge_content: "",
      // 主题id,来自课时主题列表
      theme_id: null,
      image: "",
      unit_id: "",
      description: "",
    },

    loading: {
      submit: false,
    },

    rules: {
      subject_id: [$form.rules.required("学科结构", "number")],

      structure_id: [
        { required: true, validator: validArray, trigger: "blur" },
      ],

      name: [
        $form.rules.required("课时名称"),
      ],

      title: [
        $form.rules.required("课时标题"),
      ],

      theme_id: [
        $form.rules.required("课时场景", "number"),
      ],

      knowledge_content: [
        $form.rules.required("教学知识点"),
      ],
    },

    structureProps: {
      children: "leaf",
      value: "id",
      label: "name",
    },
  }),

  computed: {
    ...mapState("course", ["subjects", "structure", "themes"]),
    ...mapState({
      initList: state => state.course.initList,
    }),
    uploadHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
    },
    qiniuType() {
      const typeMap = {
        2: "audio",
        3: "video",
        11: "image",
        12: "image",
        13: "image",
        14: "image",
        15: "image",
        16: "image",
        21: "animation",
        51: "doc",
        41: "pdf",
      };

      return typeMap[16];
    },
    isCreate() {
      return !this.data;
    },

    knowledge: {
      get() {
        return (
                this.formData.knowledge_content &&
                this.formData.knowledge_content.split(",").join("\n")
        );
      },

      set(value) {
        this.formData.knowledge_content = value && value.split("\n").toString();
      },
    },
  },

  watch: {
    visible(value) {
      this.getUnitList();
      if (value) {
        if (this.data) {
          this.image = this.data.image;
        } else {
          this.image = "";
        }
        console.log(this.data);
        this.init();
        this.$nextTick(this.clearValidate);
      } else {
        this.formData = null;
      }
    },
  },
  mounted() {
    this.getUnitList();
  },
  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),
    materialEdit({ url }, id) {
      console.log(11);
      this.loading.fetch = true;
      const name = url.split("/").pop();
      const uri = "/resource";
      const data = { name, url, type: 16 };

      this.$form_submit({ uri, data, id }).then((res) => {
        this.image = data.url;
        this.getImgList();
      }).catch((res) => {
        this.$message.error("图片资源已存在，不能上传重复图片");
      });
    },
    getImgList() {
      $http.get("/resource?page=1&equal[type]=16&per_page=20").then((res) => {
        this.imgList = res.data;
      });
    },
    modelCheckin(value, index) {
      const keys = this.findModelLocation(index);

      const lastKey = keys.pop();

      const pointer = keys
        .reduce((acc, key) => acc[key], this.theme);

      pointer[lastKey] = value;
    },
    modelCheckout(index) {
      const keys = this.findModelLocation(index);

      return keys.reduce((acc, key) => acc[key], this.theme);
    },
    // 获取所属单元列表

    getUnitList() {
      $http.get("/course/store_before").then((res) => {
        this.unitList = res.unit;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    init() {
      this.initData.image = this.image;
      const data = this.data || this.initData;
      const { subject_id } = data;
      subject_id && this.querySubject(subject_id);
      if (data.structure_id_str) {
        try {
          const arr = data.structure_id_str.split(",");
          data.structure_id = arr.map(v => parseInt(v, 10));
        } catch (e) {
          console.log("处理错误==>", e);
        }
      }
      this.formData = {
        ...data,
      };
    },

    validate() {
      this.$refs.form
        .validate(valid => valid && this.submit());
    },

    submit() {
      this.loading.submit = true;
      this.formData.image = this.image;
      const stru = this.formData.structure_id;
      this.$form_submit({
        id: this.formData.id,
        uri: "/course",
        data: {
          ...this.formData,
          structure_id: Array.isArray(stru) ? stru[stru.length - 1] : stru,
          structure_id_str: Array.isArray(stru) ? stru.toString() : stru,
        },
      })
        .then(() => {
          this.$emit("success", this.formData.id);
          this.cancel();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.$emit("update:visible", false);
    },

    clearValidate() {
      this.$refs.form.clearValidate();
    },

    querySubject(subject) {
      this.$store
              .dispatch("course/initStructure", Number(subject))
              .then((structure) => {
                const query = {
                  ...this.query,
                  subject,
                  structure,
                  page: 1,
                };

                // this.$list_routeQuery(query);
              });
    },
  },
};
</script>

<template>
  <el-dialog
    v-if="formData"
    :show-close="false"
    :visible="visible"
    width="550px"
    class="course-list-editor"
  >
    <div slot="title">
      {{ isCreate ? '创建课时' : '编辑课时' }}
    </div>

    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="7em"
    >
      <el-form-item
        label="学科结构"
        prop="subject_id">
        <el-select
          v-model="formData.subject_id"
          @change="querySubject">
          <el-option
            v-for="subject in subjects"
            :key="subject.id"
            :label="subject.name"
            :value="subject.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="课程选择"
        prop="structure_id">
        <el-cascader
          v-model="formData.structure_id"
          :options="structure"
          :props="structureProps"
          placeholder="请选择学科以及对应课时"
        />
      </el-form-item>
      <el-form-item
        label="课时名称"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          placeholder="请输入课时名称"
        />
      </el-form-item>
      <el-form-item
        label="课时标题"
        prop="title"
      >
        <el-input
          v-model="formData.title"
          placeholder="请输入课时标题"
        />
      </el-form-item>
      <el-form-item
        label="课时图片"
        class="upload"
        prop="img">
        <FileDialog
          v-model="image"
          width="100%"
          height="100%"
          type="image"
          preview
        >
          <span
            slot="placeholder"
            class="layout-placeholder"
          >
            选择图片
          </span>
        </FileDialog>

        <!--        <AppQiniu-->
        <!--          :type="'image'"-->
        <!--          width="160px"-->
        <!--          height="160px"-->
        <!--          class="view-material__item"-->
        <!--          token-url="/resource/upload_token"-->
        <!--          token-mode="name"-->
        <!--          @success="data => materialEdit(data)"-->
        <!--        />-->
        <!--        <img-->
        <!--          v-show="image"-->
        <!--          :src="image"-->
        <!--          class="uploadImg"-->
        <!--          alt="">-->
        <!-- <el-upload
          class="avatar-uploader"
          action='https://upload.qiniup.com/'
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :headers="uploadHeaders"
        >
          <img v-if="formData.image" :src="formData.image" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->
      </el-form-item>
      <el-form-item
        label="课时场景"
        prop="theme_id"
      >
        <el-select
          v-model="formData.theme_id"
          placeholder="请选增课时场景"
        >
          <el-option
            v-for="theme in themes"
            :key="theme.id"
            :label="theme.name"
            :value="theme.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="所属单元"
        prop="unit_id"
      >
        <el-select
          v-model="formData.unit_id"
          placeholder="请选择所属单元"
        >
          <el-option
            v-for="theme in unitList"
            :key="theme.value"
            :label="theme.name"
            :value="theme.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="教学知识点"
        prop="knowledge_content"
      >
        <el-input
          v-model="knowledge"
          :autosize="{ minRows: 8, maxRows: 12 }"
          type="textarea"
          placeholder="请输入教学知识点"
        />
      </el-form-item>
      <el-form-item
        label="内容介绍"
        prop="production_content"
      >
        <el-input
          v-model="formData.description"
          :autosize="{ minRows: 8, maxRows: 12 }"
          type="textarea"
          placeholder="请输入教学知识点"
        />
      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading.submit"
      @submit="validate"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss">
.course-list-editor .el-select {
  display: block;
}

.course-list-editor .el-dialog__body {
  padding-bottom: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item__content{
  display: flex;
}
.uploadImg{
  width: 160px;
  height: 160px;
  object-fit: cover;
  margin: 15px 20px;
}
.upload .dialog{
  width: 100% !important;
  height: 40px !important;
}
</style>
